module.exports = __webpack_public_path__ + "img/kimmy_desktop.c2a21b7.jpg";